<div class="driver-assignments-container">
  <!-- Filters -->
  <div class="filters-section">
    <div class="filters-inline">
      <div class="filter-item search-filter">
        <label>Search Drivers</label>
        <input
          type="text"
          [(ngModel)]="searchText"
          (input)="onSearchTextChange()"
          placeholder="Search..."
          class="search-input"
        />
      </div>
      <div class="filter-item filter-actions">
        <button
          pButton
          type="button"
          label="Clear"
          icon="pi pi-times"
          class="p-button-secondary"
          (click)="clearFilters()"
          [disabled]="!searchText"
        ></button>
        <button
          pButton
          type="button"
          icon="fa fa-file-excel-o"
          class="p-button-success"
          (click)="exportExcel()"
          title="Export to Excel"
        ></button>
      </div>
    </div>
  </div>

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-container">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <!-- Driver Assignments Table -->
  <div *ngIf="!isLoading" class="assignments-table-container">
    <table class="assignments-table">
      <thead>
        <tr>
          <th class="driver-info-col sticky-col">
            <div class="driver-col-header">
              <span>Driver</span>
              <div class="column-picker-wrapper">
                <button
                  pButton
                  type="button"
                  icon="pi pi-table"
                  class="p-button-sm"
                  (click)="showColumnPicker = !showColumnPicker"
                  pTooltip="Show/hide columns"
                  tooltipPosition="left"
                ></button>
                <div *ngIf="showColumnPicker" class="column-picker-panel">
                  <div
                    *ngFor="let col of driverInfoColumns"
                    class="column-picker-item"
                    [class.is-visible]="col.visible"
                    (click)="
                      col.visible = !col.visible;
                      onColumnVisibilityChange();
                      $event.stopPropagation()
                    "
                  >
                    <i
                      class="pi"
                      [class.pi-eye]="col.visible"
                      [class.pi-eye-slash]="!col.visible"
                    ></i>
                    <span class="col-label">{{ col.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </th>
          <th *ngIf="columnVisible['driverNo']" class="info-col info-col-driverno">Driver #</th>
          <th *ngIf="columnVisible['peopleNetId']" class="info-col info-col-peoplenet">
            PeopleNet
          </th>
          <th *ngIf="columnVisible['autoTrans']" class="info-col info-col-autotrans">Auto</th>
          <th
            *ngIf="columnVisible['doNotDispatch']"
            class="info-col info-col-do-not-dispatch"
            title="Do Not Dispatch"
          >
            <i class="fa fa-ban"></i>
          </th>
          <th *ngIf="columnVisible['team']" class="info-col info-col-team">Team</th>
          <th *ngIf="columnVisible['boardBillTo']" class="info-col info-col-boardbillto">
            Board / Bill-To
          </th>
          <th *ngIf="columnVisible['equipment']" class="info-col info-col-equipment">Equipment</th>
          <th *ngIf="columnVisible['phone']" class="info-col info-col-phone">Phone</th>
          <th *ngIf="columnVisible['homeLocation']" class="info-col info-col-home-location">
            Home
          </th>
          <th *ngIf="columnVisible['currentLocation']" class="info-col info-col-current-location">
            Current Location
          </th>
          <th *ngIf="columnVisible['note']" class="info-col info-col-note">
            Note
            <i
              *ngIf="noteSavingDriverId"
              class="fa fa-spinner fa-spin note-header-saving"
              title="Saving note…"
            ></i>
            <i
              *ngIf="!noteSavingDriverId && noteSavedDriverId"
              class="fa fa-check note-header-saved"
              title="Note saved"
            ></i>
          </th>
          <th *ngFor="let date of dateColumns; let last = last" class="date-col">
            <div class="date-header-content">
              <span>{{ formatDateHeader(date) }}</span>
              <button
                *ngIf="last"
                pButton
                type="button"
                icon="pi pi-plus"
                class="p-button-text p-button-sm add-week-btn"
                (click)="expandWeek()"
                pTooltip="Add another week"
                tooltipPosition="left"
                aria-label="Add extra week"
              ></button>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container
          *ngFor="let group of filteredSchedulingTeamGroups; trackBy: trackBySchedulingTeamId"
        >
          <!-- Scheduling Team Group Header -->
          <tr
            class="team-group-header"
            (click)="toggleSchedulingTeamExpansion(group.schedulingTeamId)"
          >
            <td [attr.colspan]="extraColumnSpan + 1" class="sticky-col team-name-cell">
              <i
                class="pi"
                [class.pi-chevron-down]="isSchedulingTeamExpanded(group.schedulingTeamId)"
                [class.pi-chevron-right]="!isSchedulingTeamExpanded(group.schedulingTeamId)"
              ></i>
              <span class="team-name">{{ group.schedulingTeamName }}</span>
              <span class="client-name">({{ group.clientName }})</span>
              <span class="driver-count">({{ group.drivers.length }} drivers)</span>
              <span
                *ngIf="group.dispatchContacts?.length"
                class="dispatch-contacts"
                (click)="$event.stopPropagation()"
              >
                <span *ngFor="let c of group.dispatchContacts" class="dispatch-contact">
                  <span *ngIf="c.name" class="contact-name">{{ c.name }}</span
                  ><span *ngIf="c.type" class="contact-type">{{ c.type }}</span
                  ><span *ngIf="c.phone" class="contact-phone">{{ formatPhone(c.phone) }}</span
                  ><span *ngIf="c.email" class="contact-email">{{ c.email }}</span>
                </span>
              </span>
            </td>
            <td [attr.colspan]="dateColumns.length" class="team-header-dates"></td>
          </tr>

          <!-- Driver Rows -->
          <ng-container *ngIf="isSchedulingTeamExpanded(group.schedulingTeamId)">
            <tr *ngFor="let row of group.drivers; trackBy: trackByDriverId" class="driver-row">
              <!-- Driver (sticky): photo + name only -->
              <td class="driver-info-cell sticky-col">
                <app-driver-card [driver]="row.driver" tooltipPosition="right">
                  <div class="driver-cell-compact">
                    <img
                      [src]="row.pictureUrl"
                      [alt]="row.displayName"
                      class="driver-picture-small"
                      onerror="this.src = 'assets/images/tractordriver.jpg'"
                    />
                    <span class="driver-name-group">
                      <a
                        class="driver-name"
                        [class.highlight]="
                          row.matchedFieldSet.has('name') || row.matchedFieldSet.has('lastName')
                        "
                        [routerLink]="['/drivers', row.driver.driverId]"
                        target="_blank"
                      >
                        {{ row.displayName }}
                      </a>
                      <i
                        *ngIf="row.openNoteCount > 0"
                        class="fa fa-exclamation-circle text-warning open-notes-icon"
                        [pTooltip]="
                          row.openNoteCount === 1
                            ? '1 open note'
                            : row.openNoteCount + ' open notes'
                        "
                        tooltipPosition="top"
                      ></i>
                    </span>
                    <button
                      type="button"
                      class="assign-schedule-btn"
                      (click)="openAssignModal(row); $event.stopPropagation()"
                      title="Assign to scheduling team"
                    >
                      <i class="fa fa-calendar-plus-o"></i>
                    </button>
                  </div>
                </app-driver-card>
              </td>

              <!-- Driver # -->
              <td *ngIf="columnVisible['driverNo']" class="info-cell info-col-driverno">
                <div class="info-cell-content">
                  <span *ngIf="row.driver.driverNo" class="meta-tag id-tag">{{
                    row.driver.driverNo
                  }}</span>
                </div>
              </td>

              <!-- PeopleNet ID -->
              <td *ngIf="columnVisible['peopleNetId']" class="info-cell info-col-peoplenet">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.peopleNetId"
                    class="meta-tag id-tag"
                    [class.highlight]="row.matchedFieldSet.has('peopleNetId')"
                    title="Peoplenet ID"
                    >{{ row.driver.peopleNetId }}</span
                  >
                </div>
              </td>

              <!-- Auto Transmission -->
              <td *ngIf="columnVisible['autoTrans']" class="info-cell info-col-autotrans">
                <span
                  *ngIf="row.driver.autoTransmissionOnly"
                  class="meta-tag auto-tag"
                  title="Auto Transmission Only"
                  >AUTO</span
                >
              </td>

              <!-- Do Not Dispatch -->
              <td *ngIf="columnVisible['doNotDispatch']" class="info-cell info-col-do-not-dispatch">
                <span *ngIf="row.driver.doNotDispatch" class="dnd-tag" title="Do Not Dispatch"
                  ><i class="fa fa-ban"></i
                ></span>
              </td>

              <!-- Team (driver's driving partners) -->
              <td *ngIf="columnVisible['team']" class="info-cell info-col-team">
                <div class="info-cell-content">
                  <span
                    *ngFor="let member of row.driver.teamMembers"
                    class="small-text team-member"
                    [class.highlight]="
                      row.matchedFieldSet.has('team') &&
                      member.toLowerCase().includes(searchText.toLowerCase().trim())
                    "
                    >{{ member }}</span
                  >
                </div>
              </td>

              <!-- Board / Bill-To -->
              <td *ngIf="columnVisible['boardBillTo']" class="info-cell info-col-boardbillto">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.boardName"
                    class="board-label"
                    [class.highlight]="row.matchedFieldSet.has('board')"
                    >{{ row.driver.boardName }}</span
                  >
                  <span
                    *ngIf="row.driver.billToClientName"
                    class="small-text"
                    [class.highlight]="row.matchedFieldSet.has('billTo')"
                    >{{ row.driver.billToClientName }}</span
                  >
                </div>
              </td>

              <!-- Equipment (Tractor + Trailer) -->
              <td *ngIf="columnVisible['equipment']" class="info-cell info-col-equipment">
                <div class="equipment-cell-content">
                  <a
                    *ngIf="row.driver.tractorNumber"
                    class="meta-tag truck-tag"
                    [class.highlight]="row.matchedFieldSet.has('tractor')"
                    [routerLink]="row.driver.tractorId ? ['/tractors', row.driver.tractorId] : null"
                    target="_blank"
                  >
                    <i class="fa fa-truck"></i> {{ row.driver.tractorNumber }}
                  </a>
                  <a
                    *ngIf="row.driver.trailerNumber"
                    class="meta-tag trailer-tag"
                    [class.highlight]="row.matchedFieldSet.has('trailer')"
                    [routerLink]="row.driver.trailerId ? ['/trailers', row.driver.trailerId] : null"
                    target="_blank"
                  >
                    <i class="fa fa-subway"></i> {{ row.driver.trailerNumber }}
                  </a>
                </div>
              </td>

              <!-- Phone Number -->
              <td *ngIf="columnVisible['phone']" class="info-cell info-col-phone">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.cellphone"
                    class="phone"
                    [class.highlight]="row.matchedFieldSet.has('cellphone')"
                  >
                    {{ row.driver.cellphone | phoneNumber }}
                  </span>
                </div>
              </td>

              <!-- Home Location -->
              <td *ngIf="columnVisible['homeLocation']" class="info-cell info-col-home-location">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.homeLocation"
                    class="location"
                    [class.highlight]="row.matchedFieldSet.has('location')"
                  >
                    {{ row.driver.homeLocation }}
                  </span>
                </div>
              </td>

              <!-- Current Location -->
              <td
                *ngIf="columnVisible['currentLocation']"
                class="info-cell info-col-current-location"
              >
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.currentLocation"
                    class="location"
                    [title]="row.driver.currentLocation"
                  >
                    {{ row.driver.parsedLocation || row.driver.currentLocation }}
                  </span>
                </div>
              </td>

              <!-- Note (editable, autosave) -->
              <td *ngIf="columnVisible['note']" class="info-cell info-col-note">
                <div class="note-edit-cell">
                  <textarea
                    class="note-textarea"
                    [value]="row.driver.specialNote || ''"
                    (input)="
                      row.driver.specialNote = $any($event.target).value;
                      onNoteChange(row.driver.driverId, row.driver.specialNote)
                    "
                    placeholder="Add note…"
                    rows="1"
                  ></textarea>
                  <i
                    *ngIf="noteSavingDriverId === row.driver.driverId"
                    class="fa fa-spinner fa-spin note-saving-indicator"
                    title="Saving…"
                  ></i>
                  <i
                    *ngIf="noteSavedDriverId === row.driver.driverId"
                    class="fa fa-check note-saved-indicator"
                    title="Saved"
                  ></i>
                </div>
              </td>

              <!-- Date Cells -->
              <td
                *ngFor="let dayData of row.days; trackBy: trackByDate"
                class="date-cell"
                [class.time-off]="dayData.isTimeOff"
                [class.estimate-34h]="!dayData.isTimeOff && dayData.isEstimate34h"
                [class.has-trips]="
                  !dayData.isTimeOff && !dayData.isEstimate34h && dayData.tripCount > 0
                "
                [class.available]="
                  !dayData.isTimeOff && !dayData.isEstimate34h && dayData.tripCount === 0
                "
                [class.event-accident]="
                  dayData.accidentIcon.hasIcon && !dayData.accidentIcon.resolved
                "
                [class.event-accident-resolved]="
                  dayData.accidentIcon.hasIcon && dayData.accidentIcon.resolved
                "
                [class.event-incident]="
                  !dayData.accidentIcon.hasIcon &&
                  dayData.incidentIcon.hasIcon &&
                  !dayData.incidentIcon.resolved
                "
                [class.event-incident-resolved]="
                  !dayData.accidentIcon.hasIcon &&
                  dayData.incidentIcon.hasIcon &&
                  dayData.incidentIcon.resolved
                "
                [class.event-breakdown]="
                  !dayData.accidentIcon.hasIcon &&
                  !dayData.incidentIcon.hasIcon &&
                  dayData.breakdownIcon.hasIcon &&
                  !dayData.breakdownIcon.resolved
                "
                [class.event-breakdown-resolved]="
                  !dayData.accidentIcon.hasIcon &&
                  !dayData.incidentIcon.hasIcon &&
                  dayData.breakdownIcon.hasIcon &&
                  dayData.breakdownIcon.resolved
                "
                [title]="
                  dayData.accidentIcon.hasIcon
                    ? dayData.accidentIcon.tooltip
                    : dayData.incidentIcon.hasIcon
                      ? dayData.incidentIcon.tooltip
                      : dayData.breakdownIcon.hasIcon
                        ? dayData.breakdownIcon.tooltip
                        : ''
                "
                (click)="onDateCellClick(row, dayData)"
              >
                <div class="date-cell-content" *ngIf="dayData.isTimeOff">
                  <span
                    *ngIf="dayData.timeOffType === 'HosReset34h'"
                    class="off-label off-label-34h"
                    title="34h Reset"
                    >34h</span
                  >
                  <span
                    *ngIf="dayData.timeOffType !== 'HosReset34h'"
                    class="off-label"
                    [title]="dayData.timeOffType || 'Time Off'"
                    >OFF</span
                  >
                </div>
                <div class="date-cell-content" *ngIf="!dayData.isTimeOff && dayData.isEstimate34h">
                  <span
                    class="off-label off-label-34h-estimate"
                    title="Estimated 34h Reset (~7 days after last reset)"
                    >~34h</span
                  >
                </div>
                <div class="date-cell-content" *ngIf="!dayData.isTimeOff && !dayData.isEstimate34h">
                  <ng-container *ngIf="dayData.tripCount > 0">
                    <div *ngFor="let trip of dayData.trips" class="trip-info">
                      <div>{{ trip.billToName }}</div>
                    </div>
                  </ng-container>
                  <span *ngIf="dayData.tripCount === 0" class="no-trips">-</span>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>

        <!-- Empty State -->
        <tr
          *ngIf="
            filteredSchedulingTeamGroups.length === 0 &&
            filteredUnassignedDriverRows.length === 0 &&
            !isLoading
          "
        >
          <td [attr.colspan]="dateColumns.length + 1 + extraColumnSpan" class="empty-state">
            <i class="pi pi-users"></i>
            <p>No driver assignments found.</p>
          </td>
        </tr>

        <!-- Unassigned Drivers Group -->
        <ng-container
          *ngIf="unassignedDriverRows.length > 0 || filteredUnassignedDriverRows.length > 0"
        >
          <tr class="team-group-header unassigned-group-header" (click)="toggleUnassignedGroup()">
            <td [attr.colspan]="extraColumnSpan + 1" class="sticky-col team-name-cell">
              <i
                class="pi"
                [class.pi-chevron-down]="unassignedGroupExpanded"
                [class.pi-chevron-right]="!unassignedGroupExpanded"
              ></i>
              <span class="team-name">Unassigned</span>
              <span class="driver-count">({{ filteredUnassignedDriverRows.length }} drivers)</span>
            </td>
            <td [attr.colspan]="dateColumns.length" class="team-header-dates"></td>
          </tr>

          <ng-container *ngIf="unassignedGroupExpanded">
            <tr
              *ngFor="let row of filteredUnassignedDriverRows; trackBy: trackByDriverId"
              class="driver-row"
            >
              <!-- Driver (sticky): photo + name only -->
              <td class="driver-info-cell sticky-col">
                <app-driver-card [driver]="row.driver" tooltipPosition="right">
                  <div class="driver-cell-compact">
                    <img
                      [src]="row.pictureUrl"
                      [alt]="row.displayName"
                      class="driver-picture-small"
                      onerror="this.src = 'assets/images/default-avatar.png'"
                    />
                    <span class="driver-name-group">
                      <a
                        class="driver-name"
                        [class.highlight]="
                          row.matchedFieldSet.has('name') || row.matchedFieldSet.has('lastName')
                        "
                        [routerLink]="['/drivers', row.driver.driverId]"
                        target="_blank"
                      >
                        {{ row.displayName }}
                      </a>
                      <i
                        *ngIf="row.openNoteCount > 0"
                        class="fa fa-exclamation-circle text-warning open-notes-icon"
                        [pTooltip]="
                          row.openNoteCount === 1
                            ? '1 open note'
                            : row.openNoteCount + ' open notes'
                        "
                        tooltipPosition="top"
                      ></i>
                    </span>
                    <button
                      type="button"
                      class="assign-schedule-btn"
                      (click)="openAssignModal(row); $event.stopPropagation()"
                      title="Assign to scheduling team"
                    >
                      <i class="fa fa-calendar-plus-o"></i>
                    </button>
                  </div>
                </app-driver-card>
              </td>

              <!-- Driver # -->
              <td *ngIf="columnVisible['driverNo']" class="info-cell info-col-driverno">
                <div class="info-cell-content">
                  <span *ngIf="row.driver.driverNo" class="meta-tag id-tag">{{
                    row.driver.driverNo
                  }}</span>
                </div>
              </td>

              <!-- PeopleNet ID -->
              <td *ngIf="columnVisible['peopleNetId']" class="info-cell info-col-peoplenet">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.peopleNetId"
                    class="meta-tag id-tag"
                    [class.highlight]="row.matchedFieldSet.has('peopleNetId')"
                    title="Peoplenet ID"
                    >{{ row.driver.peopleNetId }}</span
                  >
                </div>
              </td>

              <!-- Auto Transmission -->
              <td *ngIf="columnVisible['autoTrans']" class="info-cell info-col-autotrans">
                <span
                  *ngIf="row.driver.autoTransmissionOnly"
                  class="meta-tag auto-tag"
                  title="Auto Transmission Only"
                  >AUTO</span
                >
              </td>

              <!-- Do Not Dispatch -->
              <td *ngIf="columnVisible['doNotDispatch']" class="info-cell info-col-do-not-dispatch">
                <span *ngIf="row.driver.doNotDispatch" class="dnd-tag" title="Do Not Dispatch"
                  ><i class="fa fa-ban"></i
                ></span>
              </td>

              <!-- Team (shows team partners if any) -->
              <td *ngIf="columnVisible['team']" class="info-cell info-col-team">
                <div class="info-cell-content">
                  <span
                    *ngFor="let member of row.driver.teamMembers"
                    class="small-text team-member"
                    [class.highlight]="
                      row.matchedFieldSet.has('team') &&
                      member.toLowerCase().includes(searchText.toLowerCase().trim())
                    "
                    >{{ member }}</span
                  >
                </div>
              </td>

              <!-- Board / Bill-To -->
              <td *ngIf="columnVisible['boardBillTo']" class="info-cell info-col-boardbillto">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.boardName"
                    class="board-label"
                    [class.highlight]="row.matchedFieldSet.has('board')"
                    >{{ row.driver.boardName }}</span
                  >
                  <span
                    *ngIf="row.driver.billToClientName"
                    class="small-text"
                    [class.highlight]="row.matchedFieldSet.has('billTo')"
                    >{{ row.driver.billToClientName }}</span
                  >
                </div>
              </td>

              <!-- Equipment (Tractor + Trailer) -->
              <td *ngIf="columnVisible['equipment']" class="info-cell info-col-equipment">
                <div class="equipment-cell-content">
                  <a
                    *ngIf="row.driver.tractorNumber"
                    class="meta-tag truck-tag"
                    [class.highlight]="row.matchedFieldSet.has('tractor')"
                    [routerLink]="row.driver.tractorId ? ['/tractors', row.driver.tractorId] : null"
                    target="_blank"
                  >
                    <i class="fa fa-truck"></i> {{ row.driver.tractorNumber }}
                  </a>
                  <a
                    *ngIf="row.driver.trailerNumber"
                    class="meta-tag trailer-tag"
                    [class.highlight]="row.matchedFieldSet.has('trailer')"
                    [routerLink]="row.driver.trailerId ? ['/trailers', row.driver.trailerId] : null"
                    target="_blank"
                  >
                    <i class="fa fa-subway"></i> {{ row.driver.trailerNumber }}
                  </a>
                </div>
              </td>

              <!-- Contact -->
              <td *ngIf="columnVisible['phone']" class="info-cell info-col-phone">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.cellphone"
                    class="phone"
                    [class.highlight]="row.matchedFieldSet.has('cellphone')"
                  >
                    {{ row.driver.cellphone | phoneNumber }}
                  </span>
                </div>
              </td>

              <!-- Home Location -->
              <td *ngIf="columnVisible['homeLocation']" class="info-cell info-col-home-location">
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.homeLocation"
                    class="location"
                    [class.highlight]="row.matchedFieldSet.has('location')"
                  >
                    {{ row.driver.homeLocation }}
                  </span>
                </div>
              </td>

              <!-- Current Location -->
              <td
                *ngIf="columnVisible['currentLocation']"
                class="info-cell info-col-current-location"
              >
                <div class="info-cell-content">
                  <span
                    *ngIf="row.driver.currentLocation"
                    class="location"
                    [title]="row.driver.currentLocation"
                  >
                    {{ row.driver.parsedLocation || row.driver.currentLocation }}
                  </span>
                </div>
              </td>

              <!-- Note (editable, autosave) -->
              <td *ngIf="columnVisible['note']" class="info-cell info-col-note">
                <div class="note-edit-cell">
                  <textarea
                    class="note-textarea"
                    [value]="row.driver.specialNote || ''"
                    (input)="
                      row.driver.specialNote = $any($event.target).value;
                      onNoteChange(row.driver.driverId, row.driver.specialNote)
                    "
                    placeholder="Add note…"
                    rows="1"
                  ></textarea>
                  <i
                    *ngIf="noteSavingDriverId === row.driver.driverId"
                    class="fa fa-spinner fa-spin note-saving-indicator"
                    title="Saving…"
                  ></i>
                  <i
                    *ngIf="noteSavedDriverId === row.driver.driverId"
                    class="fa fa-check note-saved-indicator"
                    title="Saved"
                  ></i>
                </div>
              </td>

              <!-- Date Cells -->
              <td
                *ngFor="let dayData of row.days; trackBy: trackByDate"
                class="date-cell"
                [class.time-off]="dayData.isTimeOff"
                [class.estimate-34h]="!dayData.isTimeOff && dayData.isEstimate34h"
                [class.has-trips]="
                  !dayData.isTimeOff && !dayData.isEstimate34h && dayData.tripCount > 0
                "
                [class.available]="
                  !dayData.isTimeOff && !dayData.isEstimate34h && dayData.tripCount === 0
                "
                [class.event-accident]="
                  dayData.accidentIcon.hasIcon && !dayData.accidentIcon.resolved
                "
                [class.event-accident-resolved]="
                  dayData.accidentIcon.hasIcon && dayData.accidentIcon.resolved
                "
                [class.event-incident]="
                  !dayData.accidentIcon.hasIcon &&
                  dayData.incidentIcon.hasIcon &&
                  !dayData.incidentIcon.resolved
                "
                [class.event-incident-resolved]="
                  !dayData.accidentIcon.hasIcon &&
                  dayData.incidentIcon.hasIcon &&
                  dayData.incidentIcon.resolved
                "
                [class.event-breakdown]="
                  !dayData.accidentIcon.hasIcon &&
                  !dayData.incidentIcon.hasIcon &&
                  dayData.breakdownIcon.hasIcon &&
                  !dayData.breakdownIcon.resolved
                "
                [class.event-breakdown-resolved]="
                  !dayData.accidentIcon.hasIcon &&
                  !dayData.incidentIcon.hasIcon &&
                  dayData.breakdownIcon.hasIcon &&
                  dayData.breakdownIcon.resolved
                "
                [title]="
                  dayData.accidentIcon.hasIcon
                    ? dayData.accidentIcon.tooltip
                    : dayData.incidentIcon.hasIcon
                      ? dayData.incidentIcon.tooltip
                      : dayData.breakdownIcon.hasIcon
                        ? dayData.breakdownIcon.tooltip
                        : ''
                "
                (click)="onDateCellClick(row, dayData)"
              >
                <div class="date-cell-content" *ngIf="dayData.isTimeOff">
                  <span
                    *ngIf="dayData.timeOffType === 'HosReset34h'"
                    class="off-label off-label-34h"
                    title="34h Reset"
                    >34h</span
                  >
                  <span
                    *ngIf="dayData.timeOffType !== 'HosReset34h'"
                    class="off-label"
                    [title]="dayData.timeOffType || 'Time Off'"
                    >OFF</span
                  >
                </div>
                <div class="date-cell-content" *ngIf="!dayData.isTimeOff && dayData.isEstimate34h">
                  <span
                    class="off-label off-label-34h-estimate"
                    title="Estimated 34h Reset (~7 days after last reset)"
                    >~34h</span
                  >
                </div>
                <div class="date-cell-content" *ngIf="!dayData.isTimeOff && !dayData.isEstimate34h">
                  <ng-container *ngIf="dayData.tripCount > 0">
                    <div *ngFor="let trip of dayData.trips" class="trip-info">
                      <div>{{ trip.clientName }}</div>
                      <div>{{ trip.billToName }}</div>
                      <div>{{ trip.loadLocationName }}</div>
                    </div>
                  </ng-container>
                  <span *ngIf="dayData.tripCount === 0" class="no-trips">-</span>
                </div>
              </td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<!-- Date Click Modal -->
<p-dialog
  header="Manage Day"
  [(visible)]="showDateClickModal"
  [modal]="true"
  [style]="{ width: '400px' }"
  [closable]="true"
>
  <div class="date-click-modal" *ngIf="selectedDriver && selectedDate">
    <div class="modal-header-info">
      <strong>{{ getDriverDisplayName(selectedDriver) }}</strong>
      <span>{{ selectedDate | date: "fullDate" }}</span>
    </div>

    <div class="action-buttons">
      <div *ngIf="selectedDayData && selectedDayData.trips.length > 0" class="existing-trips">
        <label>Trips:</label>
        <div
          *ngFor="let trip of selectedDayData.trips"
          class="trip-list-item"
          (click)="openTripForEdit(trip.id)"
        >
          <span>{{ trip.clientName || "N/A" }}</span>
          <span *ngIf="trip.billToName"> / {{ trip.billToName }}</span>
          <span *ngIf="trip.loadLocationName"> - {{ trip.loadLocationName }}</span>
        </div>
      </div>

      <button
        pButton
        type="button"
        label="Create Time Off"
        icon="pi pi-calendar-minus"
        class="p-button-warning full-width-btn"
        (click)="openTimeOffModal()"
      ></button>

      <button
        pButton
        type="button"
        label="Create Driver Note"
        icon="pi pi-pencil"
        class="p-button-info full-width-btn"
        (click)="openDriverNoteModal()"
      ></button>

      <button
        pButton
        type="button"
        label="Create Trip"
        icon="pi pi-plus"
        class="p-button-success full-width-btn"
        (click)="openTripModalFromDateClick()"
      ></button>

      <div
        *ngIf="selectedDayData && selectedDayData.notes && selectedDayData.notes.length > 0"
        class="date-notes-list"
      >
        <label class="text-danger section-label">Accidents / Breakdowns:</label>
        <div
          *ngFor="let note of selectedDayData.notes"
          class="note-item accident-note-item"
          (click)="openDriverNoteForView(note)"
        >
          <i class="pi pi-exclamation-triangle text-danger"></i>
          <span>{{ note.type }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      label="Cancel"
      icon="pi pi-times"
      class="p-button-text"
      (click)="closeDateClickModal()"
    ></button>
  </ng-template>
</p-dialog>

<!-- Time Off Modal -->
<p-dialog
  [(visible)]="showTimeOffModal"
  [header]="isEditingTimeOff ? 'Edit Time Off Event' : 'Add Time Off Event'"
  [modal]="true"
  [style]="{ width: '500px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="time-off-modal">
    <div class="modal-header-info" *ngIf="selectedDriver">
      <strong>{{ getDriverDisplayName(selectedDriver) }}</strong>
    </div>

    <div class="form-row">
      <div class="form-group half-width">
        <label for="startDate">Start Date <span class="required">*</span></label>
        <p-calendar
          [(ngModel)]="timeOffRecord.startDate"
          dateFormat="mm/dd/yy"
          [showIcon]="true"
          [showOnFocus]="false"
          [appendTo]="'body'"
          inputId="startDate"
        >
        </p-calendar>
      </div>

      <div class="form-group half-width">
        <label for="endDate">End Date <span class="required">*</span></label>
        <p-calendar
          [(ngModel)]="timeOffRecord.endDate"
          dateFormat="mm/dd/yy"
          [showIcon]="true"
          [showOnFocus]="false"
          [appendTo]="'body'"
          inputId="endDate"
        >
        </p-calendar>
      </div>
    </div>

    <div class="form-group">
      <label for="eventType">Event Type <span class="required">*</span></label>
      <p-dropdown
        [(ngModel)]="timeOffRecord.eventType"
        [options]="eventTypeOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Event Type"
        inputId="eventType"
        [style]="{ width: '100%' }"
        appendTo="body"
      >
      </p-dropdown>
    </div>

    <div class="form-group">
      <label for="notes">Notes <span class="required">*</span></label>
      <textarea
        id="notes"
        class="form-control"
        [(ngModel)]="timeOffRecord.notes"
        rows="3"
        placeholder="Enter notes"
        required
      >
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-footer-content">
      <button
        *ngIf="isEditingTimeOff && timeOffRecord.id"
        class="btn btn-danger"
        (click)="deleteTimeOffRecord()"
      >
        <i class="fa fa-trash"></i> Delete
      </button>
      <div class="modal-footer-actions">
        <button class="btn btn-default" (click)="closeTimeOffModal()">Cancel</button>
        <button class="btn btn-primary" (click)="saveTimeOffRecord()">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>

<!-- Change Reason Dialog -->
<p-dialog
  [(visible)]="displayChangeDialog"
  header="Date Change Reason"
  [modal]="true"
  [style]="{ width: '450px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="dialog-content">
    <p class="change-warning">
      <i class="fa fa-exclamation-triangle"></i>
      You have changed the dates for this event. Please provide a reason for the change.
    </p>

    <div class="form-group">
      <label for="changeReason">Reason <span class="required">*</span></label>
      <p-dropdown
        [(ngModel)]="changeReason"
        [options]="changeReasonOptions"
        optionLabel="label"
        optionValue="value"
        placeholder="Select Reason"
        inputId="changeReason"
        [style]="{ width: '100%' }"
        appendTo="body"
      >
      </p-dropdown>
    </div>

    <div class="form-group">
      <label for="changeReasonNote">Note (Optional)</label>
      <textarea
        id="changeReasonNote"
        class="form-control"
        [(ngModel)]="changeReasonNote"
        rows="3"
        placeholder="Enter additional details (optional)"
      >
      </textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button class="btn btn-default" (click)="cancelChangeReason()">Cancel</button>
    <button class="btn btn-primary" (click)="confirmChangeReason()">Confirm</button>
  </ng-template>
</p-dialog>

<!-- Driver Note Modal -->
<app-driver-note-form-modal
  [(visible)]="showDriverNoteModal"
  [note]="driverNoteForModal"
  [driver]="driverViewModelForNoteModal"
  [tractors]="noteModalTractors"
  [trailers]="noteModalTrailers"
  [clients]="noteModalClients"
  [allClients]="noteModalAllClients"
  [products]="noteModalProducts"
  [states]="noteModalStates"
  (saved)="onDriverNoteSaved($event)"
  (closed)="onDriverNoteModalClosed()"
></app-driver-note-form-modal>

<!-- Trip Modal -->
<app-dispatch-trip-modal
  *ngIf="showTripModal"
  [tripId]="editTripId"
  [visible]="showTripModal"
  [prefilledDriverId]="tripModalDriverId"
  [prefilledClientId]="tripModalClientId"
  [prefilledBillToId]="tripModalBillToId"
  [prefilledTractorId]="tripModalTractorId"
  [prefilledTrailerId]="tripModalTrailerId"
  [prefilledProductId]="tripModalProductId"
  [prefilledStartDate]="tripModalStartDate"
  (saved)="onTripModalSaved()"
  (cancelled)="onTripModalCancelled()"
></app-dispatch-trip-modal>

<!-- Assign to Scheduling Team Modal -->
<app-assign-driver-modal
  [(visible)]="showAssignModal"
  [driverId]="assignModalDriverId"
  [existingTeamId]="assignModalExistingTeamId"
  [existingBoardId]="assignModalExistingBoardId"
  [existingBillToId]="assignModalExistingBillToId"
  (assignSuccess)="onAssignOrUpdateSuccess()"
  (updateSuccess)="onAssignOrUpdateSuccess()"
  (unassignSuccess)="onUnassignSuccess()"
  (unassignWithNote)="onUnassignWithNote($event)"
></app-assign-driver-modal>

<!-- Time Off Prompt (shown after saving Driver Release / Accident / Breakdown note) -->
<p-dialog
  header="Create Time Off Event?"
  [(visible)]="showTimeOffPromptModal"
  [modal]="true"
  [style]="{ width: '420px' }"
  [closable]="true"
  (onHide)="dismissTimeOffPrompt()"
>
  <p>
    Would you like to create a time off event for
    <strong>{{ pendingTimeOffDriverName }}</strong
    >?
  </p>
  <ng-template pTemplate="footer">
    <button class="btn btn-default" (click)="dismissTimeOffPrompt()">No</button>
    <button class="btn btn-primary" (click)="openTimeOffFromPrompt()">Yes</button>
  </ng-template>
</p-dialog>
